import { Methods } from '@api/group/get'
import { Request } from '../../request'
export default async (query:Methods["get"]["query"]) => Request( client => client.group.get.$get({query}) )
